import { useUBL } from '@common/log-manager';
import {
  getServerLogForVerticalProductCard,
  UxGoodsCardItemForVerticalProductCard as UxGoodsCardItem,
} from '@common/product-card';

export const useTopRecommendListLog = (originalProductId: string) => {
  const sendUBL = useUBL();

  const commonLog = {
    navigation: 'product_detail',
    object_section: 'top_recommendation',
  };

  const impressionProductItem = (item: UxGoodsCardItem, position: number) =>
    sendUBL({
      ...commonLog,
      category: 'impression',
      object_type: 'catalog',
      object_idx: position,
      object_id: item.catalog_product_id || '',
      data: {
        original_product_id: originalProductId,
        server_log: item.log ? getServerLogForVerticalProductCard(item.catalog_product_id, item) : undefined,
      },
    });

  const clickProductItem = (item: UxGoodsCardItem, position: number) =>
    sendUBL({
      ...commonLog,
      category: 'click',
      object_type: 'catalog',
      object_idx: position,
      object_id: item.catalog_product_id || '',
      data: {
        original_product_id: originalProductId,
        server_log: item.log ? getServerLogForVerticalProductCard(item.catalog_product_id, item) : undefined,
      },
    });

  const savedProduct = ({
    category,
    item,
    position,
  }: {
    category: 'save_product' | 'remove_saved_product';
    item: UxGoodsCardItem;
    position: number;
  }) => {
    sendUBL({
      ...commonLog,
      category,
      object_type: 'catalog',
      object_idx: position,
      object_id: item.catalog_product_id || '',
      data: {
        original_product_id: originalProductId,
        server_log: item.log ? getServerLogForVerticalProductCard(item.catalog_product_id, item) : undefined,
      },
    });
  };

  return {
    impressionProductItem,
    clickProductItem,
    savedProduct,
  };
};
